import * as React from 'react';

import styles from './styles/GuideContents.module.css';

export const GUIDE_3D_TOUR_TITLE = '3D단지투어란?';
export const GUIDE_3D_TOUR_LINES: readonly string[] = [
  '3D단지투어는 공공데이터를 활용해 아파트 단지와 주변 환경의 3D뷰를 제공하는 서비스입니다.',
  '실제와 차이가 있을 수 있으므로 단순 참고용으로만 이용해 주세요.',
  '본 서비스는 별도 합의 없이 영리 목적으로 사용할 수 없습니다.',
];

export const GUIDE_ZIGBANG_PRICE_TITLE = '직방시세란?';
export const GUIDE_ZIGBANG_PRICE_LINES: readonly string[] = [
  '직방 시세는 같은 단지 또는 주변 단지의 최근 실거래 정보를 바탕으로 추정한 가격입니다.',
  '거래 세대의 층수와 공시가격을 참고하며, 실제 가격과 차이가 있을 수 있습니다.',
];

export type GuideSectionProps = {
  title: string;
  lines: readonly string[];
  className?: string;
};

export const GuideSection: React.FC<GuideSectionProps> = ({ title, lines, className }) => {
  const sectionClass = className ? `${styles.section} ${className}` : styles.section;
  return (
    <span className={sectionClass}>
      <strong className={styles.title}>{title}</strong>
      <span className={styles.body}>
        {lines.map((line, index) => (
          <span key={index} className={styles.line}>
            {line}
          </span>
        ))}
      </span>
    </span>
  );
};
